import { getData, postData } from '../../../utils/fetch-api-util';
import { FilterTTBType, TTBType } from '../../../types/tryThenBuy';

export interface TTBRequestParams extends FilterTTBType {
  take?: number;
  page?: number;
}

export interface TTBTypeResponse {
  orders: TTBType[];
  total: number;
}

export interface cancelTTBParams {
  orderId: string;
  cancelReason: string;
}
export interface closeTTBParams {
  orderId: string;
  amountPaid: number;
  productStatusInfo?: string;
}
export interface pauseTTBParams {
  orderId: string;
  pauseReason: string;
}
export interface resumeTTBParams {
  orderId: string;
}

interface SuccessResponse {
  success: boolean;
}

export const getTTBListRepository = async (
  url: string,
  data?: TTBRequestParams,
  isRoleTTBAgent?: boolean,
): Promise<TTBTypeResponse> => {
  if (isRoleTTBAgent && data?.strSearch === '') {
    return { orders: [], total: 0 };
  }
  const response = await getData<TTBRequestParams, TTBTypeResponse>(url, data);
  return response.data;
};

export const postCancelTTBRepository = async (url: string, payload: cancelTTBParams): Promise<void> => {
  await postData<cancelTTBParams, SuccessResponse>(url, payload);
};
export const postPauseTTBRepository = async (url: string, payload: pauseTTBParams): Promise<void> => {
  await postData<pauseTTBParams, SuccessResponse>(url, payload);
};
export const postResumeTTBRepository = async (url: string, payload: resumeTTBParams): Promise<void> => {
  await postData<resumeTTBParams, SuccessResponse>(url, payload);
};
export const postCloseTTBRepository = async (url: string, payload: closeTTBParams): Promise<void> => {
  await postData<closeTTBParams, SuccessResponse>(url, payload);
};
